import {environment} from '../../environments/environment';
import * as moment from 'moment';
import Base = moment.unitOfTime.Base;

const BASE_URL = environment.apiURL;

export const API_CONSTANT = {
  'BASE_URL': BASE_URL,
  MEDIA_PATH_URL: BASE_URL + '/media/',
  delete_tax_data: BASE_URL + '/api/delete_tax_data/',
  create_document_request: BASE_URL + '/api/create_document_request/',
  patch_document_request: BASE_URL + '/api/patch_document_request/',
  documents_download: BASE_URL + '/api/documents_download/',
  request_otp: BASE_URL + '/api/auth/request-otp/',
  validate_otp: BASE_URL + '/api/auth/validate-otp/',
  login: BASE_URL + '/api-token-auth/',
  logout: BASE_URL + '/api/logout/',
  upload_csv: BASE_URL + '/api/tax_imports/',
  sign_docs: BASE_URL + '/api/sign_doc/',
  digital_signature: BASE_URL + '/api/certificate/',
  tax_data_upload_result: BASE_URL + '/api/tax_data_upload_result/',
  background_jobs: BASE_URL + '/api/background_jobs/',
  summary_csv: BASE_URL + '/api/summary_csv/',
  zip_file: BASE_URL + '/api/zip_file/',
  sales_tax_report: BASE_URL + '/api/sales_tax_report/',
  zip_file_two_megabyte: BASE_URL + '/api/zip_file_two_megabyte/',
  search_files: BASE_URL + '/api/search_files/',
  sign_counter: BASE_URL + '/api/sign_counter/',
  mark_download: BASE_URL + '/api/mark_download/',
  dashboard_monthly: BASE_URL + '/api/dashboard_monthly/',
  dashboard_sign_counter_minute: BASE_URL + '/api/dashboard_sign_counter_minute/',
  dashboard_length: BASE_URL + '/api/dashboard_length/',
  dashboard_activity: BASE_URL + '/api/dashboard_activity/',
  set_password: BASE_URL + '/api/set_password/',
  users: BASE_URL + '/api/users/',
  set_permission_access: BASE_URL + '/api/users/set_permission_access/',
  groups: BASE_URL + '/api/groups/',
  company_groups: BASE_URL + '/api/companygroups/',
  me: BASE_URL + '/api/me/',
  corporates: BASE_URL + '/api/corporates/',
  group_corporates: BASE_URL + '/api/group-corporates/',
  branches: BASE_URL + '/api/corporate-branches/',
  document_type: BASE_URL + '/api/documents_type/',
  sales_tax_view: BASE_URL + '/api/sales_tax_views/',
  export_missing_excel: BASE_URL + '/api/export_excel_missing_docs/',
  approve_sale_tax: BASE_URL + '/api/approved_sales_tax/',
  export_all_docs: BASE_URL + '/api/export_excel_all_docs/',
  export_all_docs_range: BASE_URL + '/api/export_excel_all_docs_range/',
  export_monthly_excel_report: BASE_URL + '/api/export_excel_monthly_report/',
  sales_zip_tax: BASE_URL + '/api/sales_tax_zip_views/',
  approve_upload_sale: BASE_URL + '/api/approved_uploaded_sales_tax_zip/',
  export_zip_file: BASE_URL + '/api/zip_file_two_megabyte/',
  buyer: BASE_URL + '/api/buyer/',
  b2p_document_summary: BASE_URL + '/api/b2p_document_summary/',
  b2p_document_summary_detail: BASE_URL + '/api/b2p_document_summary_detail/',
  b2p_document_summary_detail_excel: BASE_URL + '/api/b2p_document_summary_detail_excel/',
  export_billing_monthly_excel_report: BASE_URL + '/api/export_sign_counter_excel_monthly_report/',
  dashboard_sms_monthly: BASE_URL + '/api/dashboard_sms_monthly/',
  get_dashboard_length_sms: BASE_URL + '/api/get_dashboard_length_sms/',
  email_report: BASE_URL + '/api/email_report/',
  excel_email_report: BASE_URL + '/api/email_report/export-excel/',
  email_report_update_status: BASE_URL + '/api/email_report/update_status/',
  email_report_overdue: BASE_URL + '/api/email_report_overdue/',
  excel_email_report_overdue: BASE_URL + '/api/email_report_overdue/export-excel/',
  email_report_update_status_overdue: BASE_URL + '/api/email_report_overdue/update_status/',
  resend_email_sms: BASE_URL + '/api/resend_email_sms/',
  tax_data_messages: BASE_URL + '/api/tax_data_messages/',
  resend_email_sms_notify: BASE_URL + '/api/resend_email_sms_notify/',
  csv_report: BASE_URL + '/api/csv_report/',
  qr_code_payment: BASE_URL + '/api/qr_code_payment/',
  get_location: BASE_URL + '/api/get_location/',
  sms_yearly_report: BASE_URL + '/api/sms_yearly_report/',
  document_request: BASE_URL + '/api/document-requests/',
  update_invoice_payment_api_view: BASE_URL + '/api/update_invoice_payment_api_view/',
  operation_logs: BASE_URL + '/api/operation-logs/',
  action_types: BASE_URL + '/api/action-types/',
  export_actions_log_excel_report: BASE_URL + '/api/export_actions_log_excel_report/',
};



// WEBPACK FOOTER //
// /opt/app/src/app/services/api.constant.ts